import React from 'react';

const NotificationsCenterPage = () => {
    return (
        <div className="max-w-5xl mx-auto py-8 px-4">
            <h1 className="text-3xl font-bold text-secondary-900">Notifications</h1>
            <p className="mt-2 text-secondary-600">Stay up to date with your account activity.</p>
        </div>
    );
};

export default NotificationsCenterPage;
